<template>
  <div v-loading="loading">
    <div class="header">
      <el-button class="upload-demo" type="success" @click="downloadExcel">
        <img
            style="margin-right: 10px"
            alt=""
            src="@/assets/images/icons/download.svg"
        />
        Choraklar hisobotini yuklab olish
      </el-button>
      <el-select
          placeholder="Tanlang"
          v-model="region_id"
          @change="getDistricts"
      >
        <el-option :value="null" label="Viloyatlar"/>
        <el-option
            v-for="region in regions"
            :key="region.id"
            :value="region.id"
            :label="region.title"
        />
      </el-select>
      <el-select
          placeholder="Tanlang"
          v-model="district_id"
          @change="getQuarterReport"
      >
        <el-option :value="null" label="Tuman/Shahar"/>
        <el-option
            v-for="district in districts"
            :key="district.id"
            :value="district.id"
            :label="district.title"
        />
      </el-select>

      <el-select v-model="season" @change="getQuarterReport">
        <el-option
            v-for="year in years"
            :key="year"
            :value="year"
            :label="year"
        />
      </el-select>
      <el-select v-model="quarter" @change="getQuarterReport">
        <el-option
            v-for="quarter in quarters"
            :key="quarter"
            :value="quarter"
            :label="quarter"
        />
      </el-select>
      <el-button
          type="primary"
          @click="$router.push({ name: 'QuarterReportAdd' })"
      >Qo'shish
      </el-button
      >
    </div>
    <el-table :data="tableData" border height="calc(100vh - 250px)">
      <el-table-column label="T/r" align="center">
        <template #default="scope">
          {{ (page - 1) * limit + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="season" label="Yil" align="center"/>
      <el-table-column prop="quarter" label="Chorak" align="center"/>
      <el-table-column prop="region" label="Viloyat"/>
      <el-table-column prop="district" label="Tuman"/>
      <el-table-column label="Fayl" align="center">
        <template #default="scope">
          <a :href="`${BASE_IMAGE_URL}${scope.row.file_id}`" target="_blank"
          >Yuklab olish</a
          >
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="Yaratilgan sana">
        <template #default="scope">
          {{ scope.row.created_at.slice(0, 10) }}
        </template>
      </el-table-column>
      <el-table-column prop="action" label="Amallar" width="200" align="center">
        <template #default="scope">
          <el-button
              size="small"
              type="danger"
              @click="onRemove(scope.row?.id)"
          >
            O'chirish
          </el-button>
          <router-link
              class="el-button el-button--primary el-button--small"
              :to="`quarter-reports/add/${scope.row?.id}`"
          >
            Taxrirlash
          </router-link>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
          background
          layout="sizes, prev, pager, next"
          :total="count"
          v-model:page-size="limit"
          v-model:current-page="page"
      />
    </div>
  </div>
</template>

<script>
import {ElNotification} from "element-plus";

export default {
  name: "QuarterReport",
  data() {
    return {
      BASE_IMAGE_URL: `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/`,
      loading: false,
      season: 2023,
      count: 0,
      page: 1,
      limit: 10,
      years: [2020, 2021, 2022, 2023, 2024, 2025],
      quarters: [1, 2, 3, 4],
      quarter: 1,
      regions: [],
      districts: [],
      district_id: null,
      region_id: null,
      tableData: [],
      info_type: "INCOME",
      infoTypes: [
        {type: "INCOME", title: "Daromadlar"},
        {type: "OUTCOME", title: "Xarajatlar"},
      ],
    };
  },
  watch: {
    page() {
      this.getQuarterReport();
    },
    limit() {
      this.getQuarterReport();
    },
  },

  methods: {
    onRemove(id) {
      this.loading = true;
      this.$http
          .delete(`api/v1/quarterly-reports/${id}`)
          .then(() => {
            this.tableData = this.tableData.filter((v) => v.id !== id);
          })
          .catch(() => {
            ElNotification.error("Hatolik qayta urinib ko'ring!");
          })
          .finally(() => {
            this.loading = false;
          });
    },
    downloadExcel() {
      this.loading = true;
      this.$http
          .get(`api/v1/quarterly-reports/excel`, {
            responseType: "blob",
            params: {
              season: this.season,
              quarter: this.quarter,
              region_id: this.region_id,
            },
          })
          .then((res) => {
            const url = URL.createObjectURL(
                new Blob([res.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
                })
            );
            const header = res.headers.get("Content-Disposition");
            const parts = header.split(";");
            let fileName = parts[1].split("=")[1];
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch(({response}) => {
            ElNotification({
              title: "Ogohlantirish",
              message:
                  response.data.message ||
                  "Ma'lumot yuklashda xatolik sodir bo'ldi!",
              type: "warning",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    getRegions() {
      this.loading = true;
      this.$http
          .get("/api/v1/regions")
          .then(({data}) => {
            this.regions = data.regions;
            this.getQuarterReport();
          })
          .catch(() => {
          })
          .finally(() => {
            this.loading = false;
          });
    },
    getDistricts() {
      this.loading = true;
      this.$http
          .get("/api/v1/districts", {
            params: {
              region_id: this.region_id,
            },
          })
          .then(({data}) => {
            this.districts = data.districts;
            this.getQuarterReport();
          })
          .catch(() => {
          })
          .finally(() => {
            this.loading = false;
          });
    },
    getQuarterReport() {
      this.loading = true;
      this.$http
          .get(`api/v1/moderators/quarterly-reports`, {
            params: {
              season: this.season,
              quarter: this.quarter,
              region_id: this.region_id,
              district_id: this.district_id,
              limit: this.limit,
              offset: (this.page - 1) * this.limit,
            },
          })
          .then(({data}) => {
            this.tableData = data.result;
            this.count = data.count;
          })
          .catch(({response}) => {
            ElNotification.error({
              message:
                  response.data.message ||
                  "Ma'lmumot yuklashda xatolik sodir bo'ldi!",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
  },
  mounted() {
    this.getDistricts();
    this.getRegions();
  },
};
</script>

<style scoped>
.header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
  gap: 10px;
}

a {
  text-decoration: none;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
</style>
